<template>
  <section class="app_settings">
    <h2>{{ $_translations.value.page_profile_edit_section_app_settings_title }}</h2>

    <SettingsToggleItem
      text="page_profile_edit_settings_item_language"
      :selected="localeStore.currentLanguage"
      :options="languageOptions"
      @update:selected="handleLanguageChange"
    />

    <SettingsToggleItem
      text="page_profile_edit_settings_item_sounds"
      :selected="appSettingsStore.isSoundEnabled"
      :options="booleanToggleOptions"
      @update:selected="handleSoundChange"
    />

    <SettingsToggleItem
      text="page_profile_edit_settings_item_music"
      :selected="appSettingsStore.isMusicEnabled"
      :options="booleanToggleOptions"
      @update:selected="handleMusicChange"
    />
  </section>
</template>

<script setup>
import SettingsToggleItem from '@/views/profileEdit/components/item/SettingsToggleItem.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useLocaleStore from '@/store/modules/locale.js';
import useUILockHook from '@/hooks/useUILock.js';

const booleanToggleOptions = [
  { id: 'on', value: true, label: 'page_profile_edit_settings_option_on' },
  { id: 'off', value: false, label: 'page_profile_edit_settings_option_off' },
];

const appSettingsStore = useAppSettingsStore();
const localeStore = useLocaleStore();

const languageOptions = Object.entries(localeStore.languages).map(([key, value]) => ({
  id: key,
  value: key,
  label: value,
  skipTranslation: true,
}));

const [_uiLockState, setUILockState] = useUILockHook();

const handleLanguageChange = async (value) => {
  setUILockState(true);

  await localeStore.changeLanguage(value);

  setUILockState(false);
};

const handleSoundChange = (isEnabled) => {
  appSettingsStore.setSoundState(isEnabled);
};

const handleMusicChange = (isEnabled) => {
  if (isEnabled) {
    appSettingsStore.enableMusic();
  } else {
    appSettingsStore.disableMusic();
  }
};
</script>
